webpackJsonp([19],{

/***/ 2717:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _general = __webpack_require__(113);

var _password_reset_form = __webpack_require__(2718);

var _password_reset_form2 = _interopRequireDefault(_password_reset_form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
    var config = (0, _general.getConfig)(state);
    var siteName = config.SiteName;

    return {
        siteName: siteName
    };
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_password_reset_form2.default);

/***/ }),

/***/ 2718:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(272);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactIntl = __webpack_require__(761);

var _user_actions = __webpack_require__(781);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PasswordResetForm = function (_React$Component) {
    (0, _inherits3.default)(PasswordResetForm, _React$Component);

    function PasswordResetForm(props) {
        (0, _classCallCheck3.default)(this, PasswordResetForm);

        var _this = (0, _possibleConstructorReturn3.default)(this, (PasswordResetForm.__proto__ || (0, _getPrototypeOf2.default)(PasswordResetForm)).call(this, props));

        _this.handlePasswordReset = function (e) {
            e.preventDefault();

            var password = _reactDom2.default.findDOMNode(_this.refs.password).value;
            if (!password || password.length < _constants2.default.MIN_PASSWORD_LENGTH) {
                _this.setState({
                    error: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'password_form.error',
                        defaultMessage: 'Please enter at least {chars} characters.',
                        values: {
                            chars: _constants2.default.MIN_PASSWORD_LENGTH
                        }
                    })
                });
                return;
            }

            _this.setState({
                error: null
            });

            (0, _user_actions.resetPassword)(new URLSearchParams(_this.props.location.search).get('token'), password, function () {
                _this.setState({ error: null });
            }, function (err) {
                _this.setState({ error: err.message });
            });
        };

        _this.state = {};
        return _this;
    }

    (0, _createClass3.default)(PasswordResetForm, [{
        key: 'render',
        value: function render() {
            var error = null;
            if (this.state.error) {
                error = _react2.default.createElement(
                    'div',
                    { className: 'form-group has-error' },
                    _react2.default.createElement(
                        'label',
                        { className: 'control-label' },
                        this.state.error
                    )
                );
            }

            var formClass = 'form-group';
            if (error) {
                formClass += ' has-error';
            }

            return _react2.default.createElement(
                'div',
                { className: 'col-sm-12' },
                _react2.default.createElement(
                    'div',
                    { className: 'signup-team__container' },
                    _react2.default.createElement(
                        'h3',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'password_form.title',
                            defaultMessage: 'Password Reset'
                        })
                    ),
                    _react2.default.createElement(
                        'form',
                        { onSubmit: this.handlePasswordReset },
                        _react2.default.createElement(
                            'p',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'password_form.enter',
                                defaultMessage: 'Enter a new password for your {siteName} account.',
                                values: {
                                    siteName: this.props.siteName
                                }
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: formClass },
                            _react2.default.createElement('input', {
                                type: 'password',
                                className: 'form-control',
                                name: 'password',
                                ref: 'password',
                                placeholder: Utils.localizeMessage('password_form.pwd', 'Password'),
                                spellCheck: 'false'
                            })
                        ),
                        error,
                        _react2.default.createElement(
                            'button',
                            {
                                type: 'submit',
                                className: 'btn btn-primary'
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'password_form.change',
                                defaultMessage: 'Change my password'
                            })
                        )
                    )
                )
            );
        }
    }]);
    return PasswordResetForm;
}(_react2.default.Component); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

PasswordResetForm.propTypes = {
    location: _propTypes2.default.object.isRequired,
    siteName: _propTypes2.default.string
};

exports.default = PasswordResetForm;

/***/ })

});


// WEBPACK FOOTER //
// 19.19720d3969547670ae9b.js